// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-9e27d93c] .v-date-picker-table .v-btn.v-btn--active{color:#fff;background:#0014ff}.scroll-area[data-v-9e27d93c]{max-height:400px;overflow:auto}form.v-form.filter-form .v-card__text.scroll-area[data-v-9e27d93c]{padding:17px!important}.form-input[data-v-9e27d93c] .error--text{color:#ff5252!important}", ""]);
// Exports
module.exports = exports;
